import { ReactNode } from "react";
import Navbar from "./navbar";
import Footer from "./footer";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-dark text-white">
      <Navbar />
      {/* Navbar is `position: fixed` (see navbar.tsx for why) and no longer
          takes up space in the flow, so this padding stands in for it —
          `--app-navbar-height` is measured live off the real header; the
          arbitrary-value fallback only covers the instant before that first
          measurement lands. */}
      {/* At least a screen tall, so the footer starts below the fold: while a
          page loads its content is short, and a footer pinned to the bottom of
          the screen jumped away as the content arrived (layout shift). */}
      <main className="flex-grow min-h-screen pt-[var(--app-navbar-height,160px)]">
        {children}
      </main>
      <Footer />
    </div>
  );
}